module.exports = __webpack_public_path__ + "static/media/smsvaletlogo.2313ed35.svg";